<template>
    <div>
        <!-- 正常的下载页面 -->
        <div v-show="show" :class="['web-clip-wrapper', {['web-clip-'+ getWrapperType()]: true}]">
            <div class="download-wrapper" data-spm="app-3">
                <div class="download-wrapper-close" @click="closeClip">
                    <i class="icon-close"></i>
                </div>
                <div class="download-top">
                    <h6>上搜狐，知天下</h6>
                    <p>把搜狐装进手机，重大事件抢先看，拉近你与世界的距离。</p>
                </div>
                <div class="download-bottom" >
                    <a href="javascript:;" data-spm-acode="3601" target="_blank" class="download-btn" @click="downloadApk">一键安装</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import API from '../js/api';
    import Supporter from '../utils/supporter.js';
    import Util from '../utils/util.js';
    import SohuStat from '../statistics/sohu-stat.js';
    import APKUtil from '../utils/apk-util.js';

    export default {
        props: {},
        data() {
            return {
                show: false,
                os: {
                    ios: !!Supporter.os.ios,
                    android: !!Supporter.os.android
                },
                platform: {
                    safari: !!Supporter.os.ios && Supporter.isSafari,
                    qq: !!Supporter.os.android && Supporter.isQQ,
                    uc: !!Supporter.os.android && Supporter.isUC
                },
                webclip_action_id: '',
                appDownType: ''
            }
        },
        computed: {
        },
        watch: {
            show: function(val) {
                this.$nextTick(() => (window.sohuSpm && typeof window.sohuSpm.reScan === 'function') && (window.sohuSpm.reScan())) // 曝光

                if(this.os.ios && this.platform.safari) {
                    if(val) {
                        history.replaceState(null, document.title, Util.addQueryArgs(location.href, {strategyid: '00015'}));
                    }else {
                        history.replaceState(null, document.title, Util.removeQueryArgs(location.href, ['strategyid']));
                    }
                }
            }
        },
        methods: {
            getWrapperType() {
                if (this.platform.safari) {
                    return 'safari';
                } else {
                    return 'android';
                }
            },
            closeClip() {
                this.show = false;
                var closeStat = {
                    ios: '10030',
                    android: '20296'
                };
                if(this.os.ios) {
                    SohuStat.sendActionStat(closeStat.ios);
                }else {
                    SohuStat.sendActionStat(closeStat.android);
                }
                //this.$emit('close', {});
            },
            doClip() {
                this.$emit('clip', {});
            },
            downloadApk() {
                APKUtil.downloadApk(this.webclip_action_id, this.appDownType);
            },
            closeActivity () {

            }
        },
        mounted() {
            var that = this;
            //暴露全局API
            API.register("webclip_show", function (params, cal) {
                if(typeof params == 'object'){
                    that.webclip_action_id = params.webclip_action_id;
                    that.appDownType = params.app_down_type || '';
                    that.show = params.show;
                }else{
                    that.show = params;
                }
                if (typeof cal === 'function') cal();
            });
        }
    }
</script>
<style lang="less">
    @rate: 2;

    .web-clip-qq, .web-clip-uc {
        padding: 11px 60px 11px 12px;
        box-size: border-box;
        border-radius: 5px * @rate;
        background-color: #fbb724;
        box-shadow: 0 1px 1px 1px rgba(214,214,214,0.82); /*no*/
        color: #ffffff;
        font-size: 16px * @rate; /*px*/

        &::after {
            width: 0;
            height: 0;
            margin-left: -5px * @rate;
            background: none;
        }

        .web-clip-btn {
            width: 100%;
            height: 100%;
            text-align: center;
            .web-clip-btn-open {
                position: relative;
                top: 0;
                margin: 0 auto;
                box-sizing: border-box;
                line-height: 1;
            }
        }
        .web-clip-close {
            position: absolute;
            top: 50%;
            right: 3px * @rate;
            width: 22px * @rate;
            height: 22px * @rate; /*px*/
            margin-top: -10px * @rate; /*px*/
            i {
                font-size: 11px * @rate; /*px*/
                vertical-align: middle;
            }
        }
        .web-clip-logo {
            width: 48px;
            height: 48px;
        }
        .web-clip-text-action {
            margin-top: 8px;
            line-height: 48px;
            font-size: 30px;
        }
    }


    .web-clip-wrapper {
        position: fixed;
        left: 0;
        top: 0;
        z-index: 9996;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        .download-wrapper {
            position: absolute;
            left: 50%;
            top: 50%;
            width: 560px;
            height: 658px;
            overflow: hidden;
            border-radius: 15px;
            transform: translate(-50%, -50%);
            background-color: #ffffff;
            .download-wrapper-close {
                position: absolute;
                top: 30px;
                right: 30px;
                z-index: 9999;
                width: 50px;
                height: 50px;
                text-align: center;
                line-height: 50px;
                .icon-close {
                    font-size: 28px;
                    font-weight: 700;
                    color: #d8d8d8;
                }
            }
            .download-top {
                position: relative;
                z-index: 9998;
                height: 432px;
                padding: 84px 76px 0;
                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 257px;
                    background: url(../less/images/bg-download.png) no-repeat 0 0;
                    background-size: 100% 100%;
                }
                h6 {
                    margin-bottom: 20px;
                    text-align: center;
                    font-size: 38px;
                    color: #2e2e2e;
                }
                p {
                    text-align: left;
                    line-height: 38px;
                    font-size: 28px;
                    color: #969696;
                }
            }
            .download-bottom {
                position: absolute;
                left: 0;
                bottom: 0;
                z-index: 9997;
                width: 100%;
                height: 116px;
                padding-top: 60px;
                text-align: center;
                background: -webkit-linear-gradient(90deg, #ffe437, #fff27b);
                .download-btn {
                    width: 334px;
                    display: inline-block;
                    height: 86px;
                    box-shadow: 2px 2px 5px #f7db26;
                    line-height: 86px;
                    border-radius: 5px;
                    text-align: center;
                    font-size: 28px;
                    color: #997e00;
                    background: -webkit-linear-gradient(90deg, #fff2a0, #fffac2);
                }
            }
        }
    }
</style>